<template>
  
  <b-container>

    <b-row>

      <b-col>
        <p class="display-1" style="text-align:center;">
          
          

          <b-iconstack>
            <b-icon stacked icon="x-diamond-fill" scale="0.75" variant="secondary" style="color:#10486A"/>
            <b-icon stacked icon="check-all" variant="primary"/>
            
          </b-iconstack>
          
          Principal Task is Modern
        </p>

      </b-col>

      

    </b-row>
    

  </b-container>

</template>

<script>



	export default {
		name: 'App',
		components: {
		},
        data() {
          return {
            task: {},
            currentQuote: '',
            currentAuthor: ''
			}
        },
		computed: {
      appTitle: function() {
        return process.env.VUE_APP_ENV_TITLE || 'Principal Task'
      },
		},
		mounted() {
      let quoteIndex = Math.floor(Math.random() * this.quotes.length) + 1  
      this.currentQuote = this.quotes[quoteIndex].quote
      this.currentAuthor = this.quotes[quoteIndex].author

      //////console.log(quoteIndex + ": " + this.currentQuote + " by " + this.currentAuthor)

		},
		methods: {
			login() {
				this.$auth.loginWithRedirect();
			},
			logout() {
				this.$auth.logout({
					returnTo: window.location.origin
				});
			}
		}
	}
</script>

<style>


</style>